import { http } from "../../../api/http-common";

// USERS
const usersActive = async (params) => {
  try {
    const { data } = await http.get("user", { params });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
};

const usersActiveDebounced = async (params) => {
  try {
    const { data } = await http.get("user/find-users", { params });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
};

const usersActiveDebounced2 = async (params) => {
  try {
    const { data } = await http.get("user/find-users2", { params });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProfles = async (params) =>{
  try{
    const { data } = await http.get("profile/all", { params });
    return data || null;
  }catch(error){
    return Promise.reject(error);
  }
}

const getManagements = async (params) => {
  try {
    const { data } = await http.get("cost-center/" + params?.user_id, {
      params: { app_id: parseInt(process.env.VUE_APP_ID) },
    });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getAllCostCenter = async (params) => {
  try {
    const { data } = await http.get("cost-center/all", { params });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getAllManagement = async (params) => {
  try {
    const { data } = await http.get("cost-center/all-managements", { params });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
};


const getCostCenterByUser = async (params) => {
  try {
    const { data } = await http.get("cost-center/user", { params });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
}

const getManagementsUserCompany = async (params) => {
  try {
    const { user_id, company_id, user_role_id } = params;
    const { data } = await http.get(`cost-center/user-management/${user_id}`, {
      params: { company_id, user_role_id },
    });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
}

const getCostCenterByUserRole = async (params) => {
  try {
    const { data } = await http.get("cost-center/user-role", { params });
    return data || null;
  } catch (error) {
    return Promise.reject(error);
  }
}

export { 
  usersActive,
  usersActiveDebounced,
  usersActiveDebounced2,
  getManagements,
  getAllCostCenter,
  getAllManagement,
  getManagementsUserCompany,
  getCostCenterByUser,
  getCostCenterByUserRole,
  getProfles
};
